import React, { useState } from "react";
import axios from "axios";

import { Navbar } from "../../component/navbar";
import { Footer } from "../../component/footer";
import { useNavigate } from "react-router-dom";
import adminAction from "../../redux/admin/action";
import { useDispatch } from "react-redux";
import api from "../../api";
import { notify } from "../../utils/toast";

export const AdminLogin = ({ setIsAdmin, setAuthType }) => {
  const { setAdmin } = adminAction;
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [showPass, setShowPass] = useState(false);
  const [phoneNum, setPhoneNum] = useState("");
  const [loader, setLoader] = useState("");

  const [data, setData] = useState({
    email: "",
    password: "",
  });

  const onTextChange = (e) => {
    setData({ ...data, [e.target.name]: e.target.value });
  };

  const validators = () => {
    if (!data.email) {
      return "Email is required";
    }
    if (!data.password) {
      return "Password is required";
    }
    return false;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoader(true);

    try {
      const validatorsResponse = validators();

      if (validatorsResponse) {
        throw new Error(validatorsResponse);
      }

      const payload = {
        email: data?.email,
        password: data?.password,
      };
      const registerationResponse = await api.adminLogin(payload);
      console.log(registerationResponse);

      axios.defaults.headers.common["Authorization"] =
        registerationResponse.token;
      localStorage.setItem("admintoken", registerationResponse.token);
      setAuthType("admin");
      dispatch(setAdmin(registerationResponse));
      navigate("/admin/dashboard");
      setLoader(false);
    } catch (e) {
      notify.error(e.message || "Something went wrong");
      setLoader(false);
    }
  };
  return (
    <div className="homePage">
      <Navbar />
      <div className="container">
        <div className="contactPage">
          <h2 className="section-title text-center mb-45">Admin Login</h2>
          <div className="contact-form login-form">
            <form
              noValidate
              id="contactForm"
              className="ng-invalid ng-dirty ng-touched"
            >
              <div className="row">
                <div className="col-12">
                  <div className="form-group">
                    <label>Email</label>

                    <input
                      onChange={(e) => onTextChange(e)}
                      type="text"
                      name="email"
                      required
                      placeholder="Email"
                      className="form-control ng-dirty ng-invalid ng-touched"
                    />
                  </div>
                </div>
                <div className="col-12">
                  <div className="form-group">
                    <label>Password</label>

                    <input
                      onChange={(e) => onTextChange(e)}
                      type="password"
                      name="password"
                      required
                      placeholder="Password"
                      className="form-control ng-dirty ng-invalid ng-touched"
                    />
                  </div>
                </div>

                <div className="col-12 mt-4 text-center">
                  <button
                    type="submit"
                    className="themeBtn px-5"
                    onClick={handleSubmit}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};
